export class OrganizationRequiredError extends Error {
  constructor(message = 'Organization context is required for this API call') {
    super(message)
    this.name = 'OrganizationRequiredError'
  }
}
